import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiCard: Components<CssVarsTheme>['MuiCard'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      position: 'relative',
      boxShadow: 'none',
      border: '1px solid',
      borderColor: theme.vars.palette.divider,
      borderRadius: 12,
      zIndex: 0
    })
  }
};

export const MuiCardHeader: Components<CssVarsTheme>['MuiCardHeader'] = {
  defaultProps: {
    titleTypographyProps: {
      variant: 'h6',
      fontWeight: 600
    },
    subheaderTypographyProps: {
      variant: 'body2',
      marginTop: '4px'
    }
  },
  styleOverrides: {
    root: () => ({
      padding: 24,
      '& .MuiCardHeader-action': {
        marginTop: 0,
        marginRight: 0
      }
    })
  }
};

export const MuiCardContent: Components<CssVarsTheme>['MuiCardContent'] = {
  styleOverrides: {
    root: {
      padding: 8,
      '&:last-child': {
        paddingBottom: '16px'
      }
    }
  }
};
export const MuiCardActions: Components<CssVarsTheme>['MuiCardActions'] = {
  styleOverrides: {
    root: {
      padding: 0,
      paddingBottom: 4
    }
  }
};
